export const XS_VALUE = 0;
export const SM_VALUE = 375;
export const MD_VALUE = 710;
export const LG_VALUE = 1024;
export const XL_VALUE = 1440;
